import { MGetAdminCompetitionPrizePlace } from 'entities/competitions-b2b';
import { deliveryInfoFields } from '../model';

/**
 * @description Получает структуру интерфейса и возвращает массив полей для feature prize/deliveryInfo
 * @nosideeffects
 * @param prizePlace {MGetAdminCompetitionPrizePlace.Response}
 */
const useDeliveryInfoFormGeneration = /* #__PURE__ */ (prizePlace: MGetAdminCompetitionPrizePlace.Response) =>
  deliveryInfoFields.map((item) => {
    switch (item.key) {
      case 0:
        return { title: item.title, value: prizePlace.delivery_info?.address, name: item.name };
      case 1:
        return { title: item.title, value: prizePlace.delivery_info?.tracking_number, name: item.name };
      case 2:
        return { title: item.title, value: prizePlace.delivery_info?.comment_user, name: item.name };
    }
    return { title: item.title, value: prizePlace.delivery_info?.comment_admin, name: item.name };
  });

export { useDeliveryInfoFormGeneration };
